import { createFileRoute } from "@tanstack/react-router";
import { PosFigmaLP } from "@/components/posfigma/PosFigmaLP";
import profBruno from "@/assets/orto/prof-bruno.jpg.asset.json";

const TITLE = "Pós em Fisioterapia Esportiva | Versão A | FEO";
const DESC =
  "Versão A da LP: pós-graduação 100% online em Fisioterapia Esportiva. 14 módulos, 360h, reconhecida pelo MEC. Performance, prevenção e retorno ao esporte com base em evidências.";
const URL = "https://fisioemortopedia.com.br/esporte1";

export const Route = createFileRoute("/esporte1")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex" }, // LP B em teste — sai do índice até virar A
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: EsporteLP1,
});

function EsporteLP1() {
  return (
    <PosFigmaLP
      product="esporte"
      heroBadge="Pós-Graduação 100% online"
      heroTitle={["Fisioterapia", "Esportiva", "de alta performance"]}
      heroSubtitle="Avalie, trate e devolva o atleta, amador ou profissional, ao esporte com segurança, evidência e resultado."
      coordenadorNome="Bruno Saragiotto"
      coordenadorFoto={profBruno.url}
      coordenadorBio="Coordenador da pós em Fisioterapia Esportiva da FEO. PhD em fisioterapia musculoesquelética, com produção científica internacional em prevenção e tratamento de lesões esportivas e prática baseada em evidências."
      ementaSubtitle="Baixe o PDF com a grade completa dos módulos, os professores e o cronograma das aulas da pós em Fisioterapia Esportiva."
      whatsappUrl="https://nimble.li/o9yokpkm"
      whatsappLabel="Falar com o time no WhatsApp"
    />
  );
}
